import { createFileRoute } from "@tanstack/react-router";

import RecordHolderStatisticsPage from "~/pages/player/RecordHolderStatisticsPage.tsx";

export const Route = createFileRoute("/_auth/records/$playerId/statistics")({
    component: RecordHolderStatisticsPage,
});
